<template>
  <Layout>
    <div v-if="setViewDetailUjian === 'Tidak Ada Data'" class="completed-exam">
      <div class="alert alert-info d-flex align-items-center gap-2">
        <i class="bi bi-info-circle-fill"></i>
        <span>
          Ujian Sudah Dilaksanakan, Silahkan Cek Nilai Kamu di
          <b-link href="/scores" class="alert-link">Daftar Nilai</b-link>
        </span>
      </div>
    </div>

    <div v-else class="exam-container">
      <div class="row g-4 d-flex flex-lg-row flex-column-reverse">
        <!-- Left Column - Exam Card -->
        <div class="col-lg-4">
          <div class="modern-card">
            <!-- Card Header -->
            <div class="card-banner">
              <div class="banner-background"></div>
              <div class="banner-content">
                <div class="program-badges">
                  <span
                    class="badge-pill"
                    :class="{ 'is-exam': setViewDetailUjian.is_ujian }"
                    v-if="setViewDetailUjian && setViewDetailUjian.is_ujian"
                  >
                    {{ setViewDetailUjian.is_ujian ? "Ujian" : "Latihan" }}
                  </span>

                  <div
                    class="program-status"
                    v-if="
                      setViewDetailUjian &&
                        setViewDetailUjian.is_finished &&
                        setViewDetailUjian.is_answered
                    "
                  >
                    <i class="fas fa-check-circle"></i>
                    <span>Selesai</span>
                  </div>
                </div>
                <h3
                  class="program-type"
                  v-if="setViewDetailUjian && setViewDetailUjian.paket"
                >
                  {{
                    setViewDetailUjian.paket
                      .replace("Test", "")
                      .replace("Kecermatan", "Sikap Kerja")
                  }}
                </h3>
              </div>
            </div>

            <!-- Card Body -->
            <div class="card-content">
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <h5 class="program-name">
                  {{
                    setViewDetailUjian &&
                      setViewDetailUjian.paket
                        .replace("Test", "")
                        .replace("Kecermatan", "Sikap Kerja")
                  }}
                </h5>

                <span class="program-id">
                  <i class="fas fa-bookmark"></i>
                  <h6>{{ setViewDetailUjian && setViewDetailUjian.id }}</h6>
                </span>
              </div>

              <div class="program-stats">
                <div class="stat-item">
                  <i class="fas fa-file-alt"></i>
                  <span>
                    {{ setViewDetailUjian && setViewDetailUjian.length_soal }}
                    Soal
                  </span>
                </div>
                <div class="stat-item">
                  <i class="fas fa-clock"></i>
                  <span>
                    {{ setViewDetailUjian && setViewDetailUjian.waktu }}
                    Menit
                  </span>
                </div>
              </div>

              <router-link
                :to="'/student/ujian/' + setId + '/start'"
                class="action-button"
              >
                <span>Mulai Ujian</span>
                <i class="fas fa-arrow-right"></i>
              </router-link>
            </div>
          </div>
        </div>

        <!-- Right Column - Rules -->
        <div class="col-lg-8">
          <div class="rules-card">
            <h4 class="rules-title">
              Peraturan Ujian
            </h4>
            <div class="rules-list">
              <div class="rule-item">
                <div class="rule-icon">
                  <i class="fas fa-sync"></i>
                </div>
                <div class="rule-text">
                  Jangan mereload/refresh browser ketika sudah ada soal yang
                  terjawab, jika web browser di refresh maka ujian akan
                  dinyatakan selesai.
                </div>
              </div>
              <div class="rule-item">
                <div class="rule-icon">
                  <i class="fas fa-check-circle"></i>
                </div>
                <div class="rule-text">
                  Jangan menekan tombol selesai saat mengerjakan soal, kecuali
                  saat anda telah selesai mengerjakan seluruh soal.
                </div>
              </div>
              <div class="rule-item">
                <div class="rule-icon">
                  <i class="fas fa-clock"></i>
                </div>
                <div class="rule-text">
                  Perhatikan sisa waktu ujian, sistem akan mengumpulkan jawaban
                  saat waktu sudah selesai.
                </div>
              </div>
              <div class="rule-item">
                <div class="rule-icon">
                  <i class="fas fa-play-circle"></i>
                </div>
                <div class="rule-text">
                  Waktu ujian akan dimulai saat tombol
                  <strong>"Mulai Ujian!"</strong> di klik.
                </div>
              </div>
              <div class="rule-item">
                <div class="rule-icon">
                  <i class="fas fa-window-maximize"></i>
                </div>
                <div class="rule-text">
                  Jangan membuka tab baru pada saat ujian, jika membuka tab baru
                  maka ujian akan dinyatakan selesai.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import axios from "axios";

export default {
  components: {
    Layout,
  },
  page: {
    title: "Detail Ujian",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "CBT - Detail Ujian Siswa",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Student",
          href: "/student",
        },
        {
          text: "Detail Ujian",
          active: true,
        },
      ],
      setViewDetailUjian: null,
      setId: this.$route.params.id,
    };
  },
  mounted() {
    this.getViewUjian();
  },
  methods: {
    async getViewUjian() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/api/json/get-ujian-detail/${this.$route.params.id}`
        );

        if (response.data.is_answered && response.data.is_finished) {
          window.location = "/scores";
        } else {
          this.setViewDetailUjian = response.data;
        }
      } catch (error) {
        console.error("Error fetching exam details:", error);
      }
    },
  },
};
</script>

<style scoped>
.modern-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;
  border: 1px solid #eef2f7;
  height: max-content;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
}

.modern-card.disabled {
  opacity: 0.7;
  pointer-events: none;
}

/* Enhanced Banner Styling */
.card-banner {
  position: relative;
  padding: 1rem;
  min-height: 140px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.banner-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #6433a4 0%, #9166cc 100%);
  opacity: 0.95;
  z-index: 1;
}

.banner-background::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 50%
  );
}

.banner-content {
  position: relative;
  z-index: 2;
}

.banner-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.program-badges {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.badge-pill {
  padding: 0.2rem 1rem;
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.badge-pill.is-exam {
  background: rgba(255, 207, 51, 0.2);
  color: #ffe169;
  border-color: rgba(255, 207, 51, 0.3);
}

.program-id {
  font-size: 1rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.2);
  display: flex;
  gap: 0.5rem;
}

.program-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.2rem 1rem;
  background: rgba(52, 211, 153, 0.2);
  color: #4ade80;
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid rgba(52, 211, 153, 0.3);
}

.program-type {
  color: white;
  font-size: 1.4rem;
  font-weight: 600;
  margin: 2rem 0;
  line-height: 1.4;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Card Content Styling */
.card-content {
  padding: 1rem;
}

.program-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

/* Program Stats */
.program-stats {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  padding: 0.75rem;
  background: #f8fafc;
  border-radius: 12px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #64748b;
}

.stat-item i {
  color: #6433a4;
}

/* Action Button */
.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  background: #6433a4;
  color: white;
  border-radius: 12px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.action-button:hover {
  background: #522b87;
  color: white;
  text-decoration: none;
}

.action-button.completed {
  background: #e2e8f0;
  color: #64748b;
}

.action-button.completed:hover {
  background: #cbd5e1;
}

.action-button.disabled {
  background: #e2e8f0;
  color: #94a3b8;
  cursor: not-allowed;
}

/* Status Badge */
.status-badge {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: #22c55e;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  box-shadow: 0 2px 4px rgba(34, 197, 94, 0.2);
}

/* Empty State */
.empty-state {
  background: #f8fafc;
  border-radius: 16px;
  padding: 3rem;
}

/* Hover Effects */
.modern-card:hover .badge-pill {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.modern-card:hover .banner-background {
  transform: scale(1.05);
  transition: transform 0.3s ease;
}

/* Loading State */
.min-vh-75 {
  min-height: 75vh;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .program-dashboard {
    padding: 1rem 0;
  }

  .card-banner {
    min-height: 120px;
    padding: 1.25rem;
  }

  .program-type {
    font-size: 1.2rem;
  }

  .banner-header {
    flex-direction: column;
    gap: 0.75rem;
  }

  .program-badges {
    width: 100%;
    justify-content: space-between;
  }

  .card-content {
    padding: 1.25rem;
  }

  .program-name {
    font-size: 1rem;
  }

  .program-stats {
    padding: 0.5rem;
    margin-bottom: 1.25rem;
  }

  .action-button {
    padding: 0.6rem 1.25rem;
  }
}

/* Small Screen Adjustments */
@media (max-width: 576px) {
  .program-type {
    font-size: 1.1rem;
  }

  .badge-pill,
  .program-id {
    font-size: 0.8rem;
    padding: 0.35rem 0.85rem;
  }

  .program-stats {
    gap: 0.5rem;
  }
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #6c757d;
}

.stat-item i {
  font-size: 1.2rem;
  color: #7b2cbf;
}

.rules-card {
  background: white;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.08);
}

.rules-title {
  color: #7b2cbf;
  margin-bottom: 1.5rem;
  font-weight: 600;
}

.rules-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.rule-item {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.rule-icon {
  background: #7b2cbf15;
  color: #7b2cbf;
  padding: 0.8rem;
  border-radius: 0.5rem;
  flex-shrink: 0;
}

.rule-icon i {
  font-size: 1.2rem;
}

.rule-text {
  font-size: 1rem;
  color: #495057;
  line-height: 1.5;
}

.completed-exam {
  max-width: 600px;
  margin: 2rem auto;
}

@media (max-width: 768px) {
  .rules-card {
    padding: 1.5rem;
  }

  .rule-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}
</style>
